import { useTranslation } from 'react-i18next';
import KpiCard from './KpiCard';
import { useDashboardKpis } from './useDashboardKpis';

// Et kalenderår, ikoniserer "bilår" — det samlede tidsforbrug på flådens biler målt i år.
function CalendarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

export default function CarYearsWidget() {
  const { t } = useTranslation();
  const { data, loading } = useDashboardKpis();

  const years = data?.car_years ?? 0;
  const days  = data?.car_days_total ?? 0;
  const totalVehicles = data?.total_vehicles ?? 0;

  // Vis 2 decimaler hvis under 10 år, ellers 1 decimal — kompakt og læseligt
  const valueStr = years < 10
    ? years.toFixed(2).replace('.', ',')
    : years.toFixed(1).replace('.', ',');

  return (
    <KpiCard
      label={t('dashboard.kpi_car_years', { defaultValue: 'Bilår' })}
      value={valueStr}
      unit="år"
      icon={<CalendarIcon />}
      iconTone="ink"
      caption={t('dashboard.kpi_car_years_caption', {
        days: days.toLocaleString('da-DK'),
        vehicles: totalVehicles,
        defaultValue: `{{days}} dage på tværs af {{vehicles}} biler`,
      })}
      loading={loading}
    />
  );
}
